import React, { useState } from 'react';
import { Box, Button, Divider, IconButton, Menu, MenuItem, TextField } from '@mui/material';
import EventOutlinedIcon from '@mui/icons-material/EventOutlined';
import { useTranslation } from 'react-i18next';
import { addDays, toIsoDate } from '../../utils/format';

/** Quick reschedule actions; also the touch-friendly alternative to drag and drop. */
export default function RescheduleMenu({ job, onMove }) {
    const { t } = useTranslation();
    const [anchor, setAnchor] = useState(null);
    const [custom, setCustom] = useState(job.scheduledDate || '');
    const close = () => setAnchor(null);
    const move = (d) => { close(); onMove(job, d); };
    const today = new Date();

    return (
        <>
            <IconButton size="small" aria-label={t('planner.reschedule')} onClick={(e) => { e.stopPropagation(); setCustom(job.scheduledDate || ''); setAnchor(e.currentTarget); }}
                        sx={{ color: '#94A3B8', '&:hover': { color: '#427898' } }}>
                <EventOutlinedIcon sx={{ fontSize: 17 }} />
            </IconButton>
            <Menu anchorEl={anchor} open={!!anchor} onClose={close} onClick={(e) => e.stopPropagation()}>
                <MenuItem onClick={() => move(toIsoDate(today))}>{t('planner.moveToday')}</MenuItem>
                <MenuItem onClick={() => move(toIsoDate(addDays(today, 1)))}>{t('planner.moveTomorrow')}</MenuItem>
                <Divider />
                <Box sx={{ px: 2, py: 1, display: 'flex', gap: 1, alignItems: 'center' }} onKeyDown={(e) => e.stopPropagation()}>
                    <TextField type="date" size="small" value={custom} onChange={(e) => setCustom(e.target.value)} />
                    <Button size="small" variant="contained" disableElevation disabled={!custom} onClick={() => move(custom)}>{t('common.ok')}</Button>
                </Box>
                {job.scheduledDate && <Divider />}
                {job.scheduledDate && <MenuItem onClick={() => move(null)} sx={{ color: '#64748B' }}>{t('planner.unschedule')}</MenuItem>}
            </Menu>
        </>
    );
}
